// 有料オプション（snippets/flex-addon-option.liquid）の行を、対象の本商品の行に追従させる。
// 本商品が削除されたらオプションも削除し、本商品の数量が変わったらオプションを同じ数量にする。
// 本商品の行は properties._flex_addon_group、オプションの行は properties._flex_addon_parent に同じ値を持つ。
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  let running = null;

  function sync() {
    return fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const parents = {};
        cart.items.forEach((item) => {
          const group = item.properties?._flex_addon_group;
          if (group) parents[group] = (parents[group] || 0) + item.quantity;
        });

        const updates = {};
        cart.items.forEach((item) => {
          const parent = item.properties?._flex_addon_parent;
          if (!parent) return;
          const quantity = parents[parent] || 0;
          if (item.quantity !== quantity) updates[item.key] = quantity;
        });
        if (Object.keys(updates).length === 0) return;

        return fetch(`${routes.cart_update_url}.js`, {
          ...fetchConfig('json'),
          body: JSON.stringify({ updates }),
        }).then(() => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'flex-addon-cart' }));
      })
      .catch(() => {});
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // 自分の更新とオプション追加直後は対象外（追加はチェック時の数量で入れているため）
    if (event?.source === 'flex-addon-cart' || event?.source === 'flex-addon-option') return;
    if (running) return;
    running = sync().finally(() => (running = null));
  });
})();
